import React from 'react';

/**
 * Section label (spec §4) — quiet uppercase eyebrow, e.g. "ARCRYPTO RISK CHARACTER".
 */
const SectionLabel = ({ as: Tag = 'p', className = '', children, ...props }) => (
  <Tag
    className={[
      'text-[11px] font-semibold tracking-[0.04em] uppercase text-arc-ink-4',
      className,
    ].join(' ')}
    {...props}
  >
    {children}
  </Tag>
);

export default SectionLabel;
